import { ApiDateSchema, ContractSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetContractsResponseSchema = oz.object({
  countedActiveContracts: oz.number().nonnegative(),
  countedInactiveContracts: oz.number().nonnegative(),
  countedTerminatedContracts: oz.number().nonnegative(),
  countedUpcomingRenewalContracts: oz.number().nonnegative(),
  countedTotalContracts: oz.number().nonnegative(),
  countedFilteredContracts: oz.number().nonnegative(),
  contracts: oz.array(ContractSchema.extend({
    createdAt: ApiDateSchema,
    revenue: oz.number(),
  })),
}).openapi('GetContractsResponse');

export type GetContractsResponse = oz.infer<typeof GetContractsResponseSchema>;